import React, { useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../../firebase/firebaseConfig';
import { AuthContext } from '../AuthContext';

const AccountMenu = () => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { currentUser } = useContext(AuthContext);
    const isProfessorPage = location.pathname.startsWith('/professor') || location.pathname.startsWith('/simulation');
    const displayName = isProfessorPage
        ? (currentUser?.displayName || currentUser?.email?.split('@')[0] || 'Instructor')
        : 'Student';

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    // Close menu when clicking outside
    const handleClickOutside = (event) => {
        if (!event.target.closest('.account-container')) {
            setIsOpen(false);
        }
    };

    React.useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleSignOut = async () => {
        await auth.signOut();
        navigate('/');
    };

    return (
        <div style={{
            position: 'relative',
            display: 'inline-block',
            cursor: 'pointer',
            fontWeight: 'bold',
            padding: '8px 12px',
        }} className="account-container">

            {/* Username + arrow */}
            <div onClick={toggleMenu} style={{ display: 'flex', alignItems: 'center', userSelect: 'none' }}>
                <span style={{ marginRight: '8px' }}>{displayName}</span>
                {/* flip arrow based on state */}
                <div
                    style={{
                        display: 'inline-block',
                        transition: 'transform 0.3s',
                        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                        fontSize: '20px'
                    }}
                >
                    ▼
                </div>
            </div>

            {/* Dropdown menu */}
            {isOpen && (
                <div
                    style={{
                        position: 'absolute',
                        right: 0,
                        top: '100%',
                        marginTop: '4px',
                        backgroundColor: '#fff',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        minWidth: '150px',
                        zIndex: 10,
                    }}
                >
                    {isProfessorPage ? (
                        <>
                            <div
                                style={{ padding: '10px', borderBottom: '1px solid #eee', cursor: 'pointer' }}
                                onClick={() => { setIsOpen(false); navigate('/professor-dashboard'); }}
                            >
                                My simulations
                            </div>
                            <div
                                style={{ padding: '10px', cursor: 'pointer' }}
                                onClick={handleSignOut}
                            >
                                Sign Out
                            </div>
                        </>
                    ) : (
                        <>
                            <div
                                style={{ padding: '10px', borderBottom: '1px solid #eee', cursor: 'pointer' }}
                                onClick={() => { setIsOpen(false); navigate('/student-dashboard'); }}
                            >
                                My Games
                            </div>
                            <div
                                style={{ padding: '10px', cursor: 'pointer' }}
                                onClick={() => { setIsOpen(false); navigate('/'); }}
                            >
                                Leave Game
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default AccountMenu;
